export default function ChannelTag({ tag, href = '/#', large = false }) {
  return (
    <a
      href={href}
      className={`inline-block font-inter font-semibold text-[12px] text-dark-op-07 dark:text-light-op-07 rounded-full bg-dark-op-005 dark:bg-light-op-01 hover:bg-dark-op-008 dark:hover:bg-light-op-013 ${
        large ? 'px-[10px] py-[1px]' : 'px-2'
      }`}
    >
      {tag}
    </a>
  )
}
